import { CloseCircleOutlined, PlusCircleFilled } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Row,
  Table,
  Tooltip,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import search from "../../helpers/search";
import useLanguages from "../../hooks/useLanguages";
import { language_default } from "./types";
import LanguagesForm from "../LanguagesPage/LanguagesForm";
import { languageService } from "../../services/LanguageService";

const { Header, Content } = Layout;

const columns = [
  {
    title: "Language",
    dataIndex: "language",
    key: "language",
  },
];
const LanguagesPage: React.FC = function () {
  const [form] = useForm();
  const [searching, setSearching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [languagesToDisplay, setLanguagesToDisplay] = useState([]);
  const [state, setState] = useState({
    selected: language_default,
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    pagination_search: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [languages, loadingLanguages] = useLanguages(state.pagination.current);
  const onSearch = async (key: string) => {
    const { searchWord } = await form.getFieldsValue();
    if (!searchWord) {
      message.error("Please enter a valid search string!");
      return;
    }

    setSearching(true);
    const searchData = [
      {
        key,
        value: encodeURIComponent(searchWord),
      },
    ];

    const searchedData = await search(searchData, languageService, key);
    setLanguagesToDisplay(searchedData.data);
    setState({
      ...state,
      pagination_search: {
        ...state.pagination_search,
        total: searchedData.total,
        current: 1,
      },
    });
    setSearching(false);
  };


  const onClose = async () => {
    const { searchWord } = await form.getFieldsValue();
    setState({
      ...state,
    });
    setSearching(true);
    if (searchWord) {
      const searchData = [
        {
          key: "language",
          value: encodeURIComponent(searchWord),
        },
      ];

      const searchedData = await search(
        searchData,
        languageService,
        "language"
      );
      setLanguagesToDisplay(searchedData.data);
    } else {
      const searchedData = await languageService.getAll(
        state.pagination.current
      );
      const data_channelsToDisplay = searchedData.data.languages
        ? searchedData.data.languages
        : languages;
      setLanguagesToDisplay(data_channelsToDisplay);
    }

    setSearching(false);
  };

  const handleTableChange = async (pagination: any) => {
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination: pagination,
    });
    const data = await languageService.getAll(pagination.current);
    setLanguagesToDisplay(data.data.languages);
    setSearching(false);
  };

  const handleTableSearchChange = async (pagination: any) => {
    const { searchWord } = await form.getFieldsValue();
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination_search: pagination,
    });
    const searchData = [
      {
        key: "language",
        value: encodeURIComponent(searchWord),
        page: pagination.current,
      },
    ];

    const data = await search(searchData, languageService, "language");
    setLanguagesToDisplay(data.data);
    setSearching(false);
  };

  useEffect(() => {
    setLanguagesToDisplay(languages.languages);
    setState({
      ...state,
      pagination: {
        ...state.pagination,
        total: languages.total,
      },
    });
  }, [languages]);

  const loading = searching || loadingLanguages;

  return (
    <Layout style={{ padding: 20 }}>
      <Header
        style={{
          textAlign: "left",
          backgroundColor: "#F0F2F5",
          padding: 0,
          borderRadius: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <h3 style={{ fontWeight: "bold", paddingLeft: 0 }}>
              Languages (
              <span style={{ color: "#0a1e96" }}>
                {languages && languages.total ? languages.total : 0}
              </span>
              )
            </h3>
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingRight: 0 }}>
            <Button
              onClick={() => {
                setVisible(true);
                setIsCreate(true);
                setState({
                  ...state,
                  selected: language_default,
                });
              }}
              type="primary"
              shape="round"
              icon={<PlusCircleFilled />}
              style={{ width: 150 }}
            >
              Add New
            </Button>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row
          style={{
            textAlign: "left",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginTop: 0,
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24} style={{ fontWeight: "bold" }}>
                What are you looking for?
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Form
                form={form}
                initialValues={{ searchWord: "" }}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexWrap: "wrap",
                }}
                onValuesChange={(changedVals) => {
                  if (changedVals.searchWord === "") {
                    onClose();
                  }
                }}
              >
                <Col span={20}>
                  <Form.Item
                    name="searchWord"
                    shouldUpdate={(prev, cur) => {
                      if (cur.searchWord === "") {
                        onClose();
                      }
                      return true;
                    }}
                  >
                    <Input
                      style={{ width: 300, borderRadius: 10 }}
                      placeholder={"Search"}
                      suffix={
                        <Tooltip title="Clear Search">
                          <CloseCircleOutlined
                            onClick={() => {
                              setIsCreate(false);
                              setLanguagesToDisplay(languages.languages);
                              setState({
                                ...state,
                                pagination: {
                                  current: 1,
                                  pageSize: 10,
                                  total: languages.total,
                                },
                              });
                              form.setFieldsValue({
                                searchWord: "",
                              });
                            }}
                            style={{
                              color: "rgba(0,0,0,.45)",
                            }}
                          />
                        </Tooltip>
                      }
                    ></Input>
                  </Form.Item>

                </Col>
                <Col span={4} style={{ textAlign: "right", paddingRight: 0 }}>
                  <Form.Item>
                    <Button
                      type="primary"
                      shape="round"
                      htmlType="submit"
                      onClick={() => onSearch("language")}
                      style={{ width: 160 }}
                    >
                      Search By Language
                    </Button>
                  </Form.Item>

                </Col>
              </Form>

            </Row>
          </Col>
        </Row>
        <Row
          style={{
            padding: 20,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 15,
          }}
        >
          <Col span={24}>
            {form.getFieldValue("searchWord") === "" ? (
              <Table
                pagination={state.pagination}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        selected: record,
                      });
                      setIsCreate(false);
                      setVisible(true);
                    },
                  };
                }}
                dataSource={languagesToDisplay}
                columns={columns}
                onChange={handleTableChange}
              />
            ) : (
              <Table
                pagination={state.pagination_search}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        selected: record,
                      });
                      setIsCreate(false);
                      setVisible(true);
                    },
                  };
                }}
                dataSource={languagesToDisplay}
                columns={columns}
                onChange={handleTableSearchChange}
              />
            )}
          </Col>
        </Row>
      </Content>
      <LanguagesForm
        visible={visible}
        form={form}
        values={
          isCreate
            ? { ...language_default }
            : {
              ...state.selected,
            }
        }
        isChanged={false}
        setVisible={setVisible}
        isCreate={isCreate}
        onClose={onClose}
      />
    </Layout>
  );
};

export default LanguagesPage;
